import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import EmailRegStore from '../../../stores/EmailRegStore';
import RegOptionsStore from '../../../stores/RegOptionsStore';
import SnackStore from '../../../stores/SnackStore';
import FuseConfirmationModal from '../../ConfirmationModal/FuseConfirmationModal';
import FuseButton from '../../FuseControls/FuseButton';
import { FTBody, FTCaption } from '../../Fuse';
import FuseConsoleModal from '../../ConsoleModal/FuseConsoleModal';
import Card from '../../Fuse/Card';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import UrlBulkEditor from '../../BulkEditor/UrlBulkEditor';
import Icon from '../../Icon/Icon';
import './EmailDomainsModal.css';

const block = b.lock('EmailDomainsModal');

class EmailDomainsModal extends Component {
    static propTypes = {
        emailReg: EmailRegStore.PropType.isRequired,
        regOptions: RegOptionsStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    state = {
        invalidCount: 0,
    };

    constructor(props) {
        super(props);
        this.cardRef = React.createRef();
    }

    componentDidMount() {
        const { emailReg } = this.props;

        this.trackCardWidthInterval = setInterval(() => {
            if (this.cardRef.current) {
                clearInterval(this.trackCardWidthInterval);
                emailReg.domainsBulkEditor.updateWidth(this.cardRef.current.offsetWidth);
            }
        }, 100);
    }

    onSaveClick = () => {
        const { snack, emailReg, regOptions } = this.props;
        emailReg.verifyDomains()
            .then((isValid) => {
                if (isValid) {
                    return emailReg.save().then((data) => {
                        regOptions.setEmailReg(data);
                        snack.showSuccess(<span><b key={'bold'}>Associated Email Domains</b> has been saved.</span>);
                    });
                }
                this.setState({ invalidCount: this.state.invalidCount + 1 });
            })
            .catch(() => snack.showError('Your request could not be processed. Please try again'));
    };

    renderHeaderAction = () => {
        const { emailReg } = this.props;

        return <FuseButton
            style={{ minWidth: 100 }}
            color={'green'}
            primary
            disabled={!emailReg.hasChanged || !emailReg.domainsBulkEditor.bulkEditorStore.isValid()}
            loading={emailReg.saveStatus.isLoading || emailReg.verifyStatus.isLoading}
            onClick={this.onSaveClick}
        >Save</FuseButton>;
    };

    getErrorMessage = (failedValidatorsIndexes) => {
        const haveInvalidDomains = failedValidatorsIndexes.includes(EmailRegStore.INVALID_DOMAIN_VALIDATOR_INDEX);
        const haveAlreadyUsedDomains = failedValidatorsIndexes.includes(EmailRegStore.DUPLICATE_DOMAIN_VALIDATOR_INDEX);

        if (haveInvalidDomains && haveAlreadyUsedDomains) {
            return 'The following email domains are invalid or already in use. Please correct and try again.';
        }
        if (haveAlreadyUsedDomains) {
            return 'The following email domains are already in use. Please correct and try again.';
        }
        if (haveInvalidDomains) {
            return 'The following email domains are invalid. Please correct and try again.';
        }
        return '';
    };

    render() {
        const { emailReg, regOptions } = this.props;

        return <FuseConsoleModal
            isOpen={emailReg.domainsModal.isOpen}
            onClose={emailReg.close}
            title="Edit Associated Email Domains"
            className={block()}
            contentClassName={block('Content')}
            headerActions={this.renderHeaderAction()}
        >
            <Card
                title={<div className={block('CardHeader')}>
                    Associated Email Domains
                    <FuseInfoTooltip>
                        These email domains will be used to lookup this account for registration and login routing.
                    </FuseInfoTooltip>
                </div>}
            >
                <FTBody>Enter email domains below (1 entry per line).</FTBody>

                <div ref={this.cardRef} className={block('BulkEditorContainer')}>
                    <UrlBulkEditor
                        cardWrapperClassName={block('BulkEditorCardWrapperContainer')}
                        cardClassName={block('BulkEditorCardContainer')}
                        validUrlText={'Entries'}
                        placeholder={'Enter or paste email domains'}
                        warningMessage={'Duplicate email domains will be deleted on save'}
                        getErrorMessage={this.getErrorMessage}
                        store={emailReg.domainsBulkEditor}
                        invalidCount={this.state.invalidCount}
                    />
                </div>
            </Card>

            {regOptions.primaryDomain ? <Card title={'Primary Domain'}>
                <FTBody>{regOptions.primaryDomain}</FTBody>

                <FTCaption className={block('PrimaryDomainInfo')}>
                    <Icon type={'info'} className={block('InfoIcon')} />
                    The primary domain is associated with the email address of the Primary Admin.
                    Please contact support for any changes needed.
                </FTCaption>
            </Card> : null}

            <FuseConfirmationModal
                store={emailReg.exitConfirmationModal}
                onConfirm={emailReg.domainsModal.close}
            />
        </FuseConsoleModal>;
    }
}

export default inject('snack', 'emailReg', 'regOptions')(observer(EmailDomainsModal));
